import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';

interface UnauthorizedProps {
  message?: string;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({ 
  message = "You don't have permission to access this page." 
}) => {
  return (
    <div className="app-container">
      <Header />
      <main style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <div style={{ 
          fontSize: '4rem', 
          marginBottom: '1rem',
          color: 'var(--destructive)'
        }}>
          🔒
        </div>
        <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Access Denied</h2>
        <p style={{ color: 'var(--muted-foreground)', marginBottom: '2rem', maxWidth: '500px' }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Link 
            to="/" 
            style={{ 
              padding: '0.75rem 1.5rem', 
              background: 'var(--secondary)', 
              color: 'var(--foreground)', 
              borderRadius: '6px', 
              textDecoration: 'none',
              fontWeight: 600,
              border: '1px solid var(--border)'
            }}
          >
            Go Home
          </Link>
          <button 
            onClick={() => window.history.back()}
            style={{ 
              padding: '0.75rem 1.5rem', 
              background: 'var(--primary)', 
              color: 'var(--primary-foreground)', 
              borderRadius: '6px', 
              border: 'none',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Go Back
          </button>
        </div>
      </main>
    </div>
  );
};

